import { useMprcTheme } from "components/MprcThemeProvider";
import { IMprcIconButtonDropdownProps, MprcIconButtonDropdown } from "./MprcIconButtonDropdown";
import { IconCircleEllipsis } from "./icons/IconCircleEllipsis";

////////////////////////////////////////////////////////////////////////////////

type IProps<T> = Omit<IMprcIconButtonDropdownProps<T>, "icon">;

export const MprcIconButtonMoreOptionsDropdown = <T extends unknown>(props: IProps<T>) => {
    const { title, separator = "blank", color = "muted", disabled = false, ...rest } = props;

    const { theme } = useMprcTheme();
    const lTitle = title || theme.MprcIconButtonMoreOptionsDropdown.title;

    return (
        <MprcIconButtonDropdown
            {...rest}
            disabled={disabled}
            title={lTitle}
            color={color}
            separator={separator}
            icon={<IconCircleEllipsis size="xs" />}
        />
    );
};
